








































import { Vue, Component, Prop } from 'vue-property-decorator'
import util from '../../../common/util'
// @ts-ignore
import ImagesPreviewer from '@lx-frontend/images-previewer'

interface ILeaveTrace {
  car_incoming_type: string
  description: string
  exit_category_info: string
  image_urls: string[]
  occurred_at: string
  [prop: string]: any
}

@Component({
  components: {
    ImagesPreviewer
  }
})
export default class TraceRecord extends Vue {
  @Prop({ type: Object, default: () => {} }) readonly leaveTrace!: ILeaveTrace

  id: string | number = 0
  imageList = []
  options = {
    getThumbBoundsFn (index: any) {
      let isServer = typeof window === 'undefined'
      if (isServer) return
      let thumbnail = document.querySelectorAll('.previewer-img')[index]
      let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
      let rect = thumbnail.getBoundingClientRect()
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
    }
  }

  goPic(current: string, urls: string[]) { // 查看图片
    this.$wechat.wx.previewImage({
      current,
      urls
    })
  }
}
